import React from "react";
import "../workexperience/workExperience.css";
import InquiryForm from "../InquiryForm";

const WorkExperienceEurope = () => {
  return (
    <div className="work-experience-container">

      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-text">
          <h1>International Work Experience in Europe</h1>
          <p>
            Discover unparalleled professional opportunities in Europe, home to some of the world's 
            most robust and diverse economies. From the financial hubs of London and Frankfurt to 
            the tech scenes in Berlin and Stockholm, Europe offers a unique blend of rich cultural 
            heritage and modern innovation.
          </p>
        </div>

        <div className="hero-image">
          <img
            src="https://images.unsplash.com/photo-1467269204594-9661b134dd2b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
            alt="Work in Europe - Paris"
          />
        </div>
      </section>

      {/* DEFINITION SECTION */}
      <section className="definition-section">
        <h2>What is Work Experience?</h2>
        <p>
          Gaining international work experience in Europe can be a great way to boost your career. 
          To achieve this, you can explore various options such as internships, work exchanges, 
          or direct employment. Consider starting with researching job markets, building a strong 
          resume, improving language skills, networking, and applying for necessary visas.
        </p>
        <p>
          The economies of many European countries are not only robust but diverse, offering a wide 
          variety of opportunities for those looking for internships in Europe. Landmark cities and 
          economic goliaths such as Paris, Berlin, Madrid, London, and more call people from all 
          corners of the globe to engage in their thriving business sectors.
        </p>
        <p>
          Not only does an internship in Europe offer you the chance to experience beautiful landscapes 
          and unique culinary cultures, but you'll also gain first-hand experience and build an 
          international network in locations where its rich culture not only embraces but precedes 
          mass globalization.
        </p>
      </section>

      {/* HIGHLIGHTS SECTION */}
      <section className="highlights-section">
        <h2>Why Choose Europe?</h2>
        <div className="highlights-grid">
          <div className="highlight-card">
            <h3>🌍 Diverse Economies</h3>
            <p>Opportunity to work in multiple developed European countries with strong economies.</p>
          </div>

          <div className="highlight-card">
            <h3>🚀 Early Career Start</h3>
            <p>Get an opportunity to work at international level right at the beginning of your career.</p>
          </div>

          <div className="highlight-card">
            <h3>👥 Professional Guidance</h3>
            <p>Get real work experience under the guidance of experienced European professionals.</p>
          </div>

          <div className="highlight-card">
            <h3>📚 Skill Enhancement</h3>
            <p>It helps to improve your skills and knowledge in diverse work environments.</p>
          </div>

          <div className="highlight-card">
            <h3>💰 Financial Benefits</h3>
            <p>You also get monthly salary / stipend with competitive European pay scales.</p>
          </div>

          <div className="highlight-card">
            <h3>⚡ Global Readiness</h3>
            <p>It makes you ready to face challenges in this competitive international market.</p>
          </div>

          <div className="highlight-card">
            <h3>🎯 For Everyone</h3>
            <p>Helpful for fresher and even for experienced professionals seeking European exposure.</p>
          </div>

          <div className="highlight-card">
            <h3>🌐 International Network</h3>
            <p>Help to work at international level and build connections across Europe.</p>
          </div>

          <div className="highlight-card">
            <h3>💪 Confidence Building</h3>
            <p>It improves your confidence by exposing you to multicultural work environments.</p>
          </div>

          <div className="highlight-card">
            <h3>📄 Enhanced Resume</h3>
            <p>It makes your resume strong with valuable European work experience.</p>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section className="benefits-section">
        <h2>Key Benefits</h2>
        <ul className="benefits-list">
          <li>Work in multiple countries with one visa (EU Blue Card)</li>
          <li>Excellent work-life balance culture</li>
          <li>Comprehensive social security benefits</li>
          <li>Competitive salary packages</li>
          <li>Rich cultural experiences</li>
          <li>Language learning opportunities</li>
          <li>Strong worker protections</li>
          <li>Easy travel across Schengen area</li>
        </ul>
      </section>

      {/* OPPORTUNITIES SECTION */}
      <section className="opportunities-section">
        <h2>Work Opportunities</h2>
        <div className="opportunity-grid">
          <div className="opportunity-item">
            <h3>💻 Tech & Startup</h3>
            <p>Berlin, Stockholm, Amsterdam - Europe's silicon valleys</p>
          </div>
          <div className="opportunity-item">
            <h3>🏦 Finance & Banking</h3>
            <p>London, Frankfurt, Zurich - Global financial hubs</p>
          </div>
          <div className="opportunity-item">
            <h3>🏭 Engineering</h3>
            <p>Germany, Switzerland - World-class engineering</p>
          </div>
          <div className="opportunity-item">
            <h3>🎨 Design & Fashion</h3>
            <p>Milan, Paris, Barcelona - Creative industries</p>
          </div>
        </div>
      </section>

      {/* COUNTRIES SECTION */}
      <section className="countries-section">
        <h2>Major Work Destinations</h2>
        <div className="countries-list">
          <span className="country-tag">🇬🇧 London</span>
          <span className="country-tag">🇩🇪 Berlin</span>
          <span className="country-tag">🇫🇷 Paris</span>
          <span className="country-tag">🇪🇸 Madrid</span>
          <span className="country-tag">🇮🇹 Milan</span>
          <span className="country-tag">🇳🇱 Amsterdam</span>
          <span className="country-tag">🇨🇭 Zurich</span>
          <span className="country-tag">🇸🇪 Stockholm</span>
          <span className="country-tag">🇮🇪 Dublin</span>
          <span className="country-tag">🇩🇰 Copenhagen</span>
        </div>
      </section>

      {/* INQUIRY FORM */}
      <InquiryForm title="Inquire About Work Experience in Europe" />

    </div>
  );
};

export default WorkExperienceEurope;